import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import SubContentTemplate from '@appbase/templates/SubContentTemplate.vue'
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue';
import { MigBoardHeader, MigBoardList } from '@home/components/YWK_MigBoard'
import api from '@home/api/index'

@Component({
    components: { SubContentTemplate, PageNavigationBar, MigBoardHeader, MigBoardList },
})
export default class YWK_MigBoardContainer extends Vue {
    @Prop({type:String, default:''}) boardName!:string
    @Prop({type:Number}) selectedMenuId!: number


    pageNumber:number = 1;
    rowCount:number = 15;
    totalCount:number =0;
    keyword:string = '';

    YWKArticles:Array<ywkMigration.article>=[]
    isLoading:boolean = false;

    load(){
        this.isLoading=true;
        api.ywkboard.getArticles({boardId:this.selectedMenuId,page:this.pageNumber,itemsPerPage:this.rowCount,keyword:this.keyword}).then(res=>{
            this.YWKArticles = res.data;
            this.totalCount = res.totalCount;
            this.pageNumber = res.currentPage;
        })
        this.isLoading=false
    }

    pageMove(num:number){
        this.pageNumber = num
        this.load();
    }

    searchClick(val:string){
        this.keyword = val
        this.pageNumber = 1
        this.load();
    }

    reset(){
        this.keyword=''
        this.load();
    }

    @Watch('selectedMenuId')
    reloadList(newVal:number){
        this.pageNumber = 1
        this.keyword=''
        this.load();
    }

    created(){
        this.load()
    }
    
}
